import moment from 'moment'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Text } from '../../../..'
import { getColorForMarketIndex } from '../../../../../helpers/withColorIndex'
import { MARKET_TEMP_HEADERS } from '../../../../../constants/messages'
import styles from './ChartTooltip.module.scss'

const ChartTooltip = ({ value, month, flipTooltipPosition, leftAlignmentPercentage }) => {
  const getMsgKeyByMarketTempValue = () =>
    Object.keys(MARKET_TEMP_HEADERS).find(key => {
      const tempValueBounds = key.split('-')
      return value >= tempValueBounds[0] && value <= tempValueBounds[1]
    })

  const color = getColorForMarketIndex(value, '--brand-market-temp')
  const fontColor = getColorForMarketIndex(value, '--brand-market-temp-font')
  const marketMsg = MARKET_TEMP_HEADERS[getMsgKeyByMarketTempValue(value)]

  return (
    <div className={styles.tooltip}>
      <div
        className={styles.point}
        style={{
          borderColor: color,
          background: color,
          left: leftAlignmentPercentage,
          bottom: `${value}%`
        }}
      />
      <div
        style={{ left: leftAlignmentPercentage, bottom: `${value}%` }}
        className={classnames(styles.box, flipTooltipPosition && styles.showTooltipLeftOfPoint)}
      >
        <Text weight='semibold' style={{ color: fontColor }}>
          <FormattedMessage {...marketMsg} />
        </Text>
        <Text transform='uppercase' size='s' letterSpacing='10' weight='semibold'>
          {moment(`${month}-02`).format('MMM YY')}
        </Text>
      </div>
    </div>
  )
}

ChartTooltip.propTypes = {
  leftAlignmentPercentage: PropTypes.string,
  flipTooltipPosition: PropTypes.bool,
  value: PropTypes.number,
  month: PropTypes.string
}

export default ChartTooltip
